module.exports = __webpack_public_path__ + "img/backoffice-not-allowed.c3be5f18.svg";